import { RadioButtonGroup, TextArea } from 'framework/form';
import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';

type ApplicationCandidateDecisionDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const FINAL_DECISIONS = [
  { value: 'MAKE_OFFER', label: 'Make offer' },
  { value: 'REJECT', label: 'Reject the candidate' },
];

const FULL_ROW_SIZE = { xs: 12, md: 12, xl: 12 };

const CANDIDATE_DECISION_SECTIONS: CreateEditFormSection[] = [
  {
    id: 'decision',
    fields: [
      {
        id: 'decision',
        size: FULL_ROW_SIZE,
        content: <RadioButtonGroup source="decision" label="" options={FINAL_DECISIONS} />,
      },
    ],
  },
  {
    id: 'decisionDetails',
    fields: [
      {
        id: 'decisionDetails',
        size: FULL_ROW_SIZE,
        content: <TextArea source="decisionDetails" label="Decision details" rows={4} />,
      },
    ],
  },
];

const ApplicationCandidateDecisionDrawer = ({ isOpen, onClose }: ApplicationCandidateDecisionDrawerProps) => (
  <CreateEditFormDrawer
    isOpen={isOpen}
    onClose={onClose}
    title="Make final decision"
    initialData={{ decision: 'MAKE_OFFER' }}
    isCreateRequest
    submitFormFunc={async () => {}}
    afterSubmit={{ execute: onClose, message: 'Final decision saved.' }}
    submitButtonTitle="Submit"
    handleDirty={false}
    getSections={() => CANDIDATE_DECISION_SECTIONS}
  />
);

export default ApplicationCandidateDecisionDrawer;
